import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link } from "react-router-dom";

export default function Segmentos() {
  return (
    <ul className="segmentos">
        <li className='mayores'><Link to='/adultos-mayores'><span>Tengo<br />más de 60</span></Link></li>
        <li className='adolescentes'><Link to='/adolescentes'><span>Tengo entre<br />13 y 17 años</span></Link></li>
        <li className='emprendedora'><Link to='/mujer-emprendedora'><span>Soy mujer<br />emprendedora</span></Link></li>
        <li className='micro'><Link to='/micro-emprendimientos'><span>Tengo un micro-<br />emprendimiento</span></Link></li>
        <li className='funcionario'><Link to='/funcionario-municipal'><span>Soy funcionaria/o<br />municipal</span></Link></li>
    </ul>
  );
}